import { render, staticRenderFns } from "./CollapseAreaPreservacaoPermanente.vue?vue&type=template&id=6b9ba7ce&lang=pug"
import script from "./CollapseAreaPreservacaoPermanente.vue?vue&type=script&lang=js"
export * from "./CollapseAreaPreservacaoPermanente.vue?vue&type=script&lang=js"
import style0 from "./CollapseAreaPreservacaoPermanente.vue?vue&type=style&index=0&id=6b9ba7ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports